import { render, staticRenderFns } from "./AlarmOrderTable.vue?vue&type=template&id=2d976bcc&scoped=true"
import script from "./AlarmOrderTable.vue?vue&type=script&lang=js"
export * from "./AlarmOrderTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmOrderTable.vue?vue&type=style&index=0&id=2d976bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d976bcc",
  null
  
)

export default component.exports